"use strict";
// Styles for use for lineage bars for filtered lineage items
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var LayoutComponents_1 = require("./LayoutComponents");
var StyleFunctions_1 = require("./StyleFunctions");
var VizPortalStyles_1 = require("./VizPortalStyles");
var Spacing = widgets_1.TabStyles.Spacing;
var filteredBlue = 'rgb(52, 152, 219)';
exports.lineageBarMaxWidth = 80;
exports.lineageBarHeight = 4;
exports.cellBarMaxWidth = '100%';
exports.cellBarHeight = VizPortalStyles_1.ListViewRowOuterHeight - (2 * Spacing.DefaultSpace);
exports.animatedBarWidthStyle = {
    transition: 'width 500ms 0ms',
};
exports.baseBarStyle = {
    maxWidth: '100%',
    width: '100%',
    position: 'relative'
};
exports.filteredBarStyle = {
    maxWidth: '100%',
    backgroundColor: VizPortalStyles_1.Grey218,
    width: 0,
    position: 'absolute',
    left: 0,
    top: 0
};
exports.baseBarClass = StyleFunctions_1.cssClass('baseBar', exports.baseBarStyle);
exports.filteredBarClass = StyleFunctions_1.cssClass('filteredBar', exports.filteredBarStyle);
exports.animatedBaseBarClass = StyleFunctions_1.cssClass('animatedBaseBar', exports.baseBarStyle, exports.animatedBarWidthStyle);
exports.animatedFilteredBarClass = StyleFunctions_1.cssClass('animatedFilteredBarClass', exports.filteredBarStyle, exports.animatedBarWidthStyle);
exports.BarLabel = LayoutComponents_1.divWithStyle('barLabel', {
    position: 'absolute',
    marginLeft: Spacing.DefaultSpace
});
exports.cellAlignmentStyle = {
    display: 'inline-block',
    verticalAlign: 'middle',
    width: "calc(100% - " + (Spacing.MediumSpace || 0) * 2 + "px)",
    paddingLeft: Spacing.MediumSpace,
    paddingRight: Spacing.MediumSpace,
};
exports.cellAlignmentClass = StyleFunctions_1.cssClass('cellAlignment', exports.cellAlignmentStyle);
exports.disabledCellAlignmentClass = StyleFunctions_1.cssClass('disabledCellAlignment', __assign(__assign({}, exports.cellAlignmentStyle), { opacity: 0.6 }));
exports.lineageBarColors = StyleFunctions_1.cssClass('lineageBarColors', {
    $nest: (_a = {},
        _a["." + exports.animatedBaseBarClass] = {
            backgroundColor: VizPortalStyles_1.Grey218,
        },
        _a["." + exports.animatedFilteredBarClass] = {
            backgroundColor: filteredBlue,
        },
        _a)
});
exports.spacesBarColors = StyleFunctions_1.cssClass('spacesBarColors', {
    $nest: (_b = {},
        _b["." + exports.filteredBarClass] = {
            backgroundColor: VizPortalStyles_1.Grey218
        },
        _b)
});
exports.connectToBarColors = StyleFunctions_1.cssClass('connectToBarColors', {
    $nest: (_c = {},
        _c["." + exports.filteredBarClass] = {
            backgroundColor: filteredBlue
        },
        _c)
});
exports.colorPalettes = {
    spaces: exports.spacesBarColors,
    connectTo: exports.connectToBarColors,
    lineage: exports.lineageBarColors
};
//# sourceMappingURL=CountBarStyles.js.map